import React from "react";
import ReactDOM from "react-dom/client";
// Lot 2A — polices auto-hébergées (SIL Open Font License 1.1), plus aucun appel à fonts.googleapis.com / fonts.gstatic.com
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@/styles/tokens.css";
import "@/index.css";
import "@/da-v2.css";
import { initDA } from "@/lib/da";
import App from "@/App";

initDA();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
